/**
 * Permission Constants
 * 
 * ⚠️ AUTO-GENERATED: This file is generated from config/permissions.php
 * Run: php artisan permissions:generate-frontend-constants
 * 
 * DO NOT EDIT THIS FILE MANUALLY
 */

export const PERMISSIONS = {
  CRM: {
    ACCOUNTS: {
      VIEW: 'crm.accounts.view',
      CREATE: 'crm.accounts.create',
      EDIT: 'crm.accounts.edit',
      DELETE: 'crm.accounts.delete',
    },
    SUBACCOUNTS: {
      VIEW: 'crm.subaccounts.view',
      CREATE: 'crm.subaccounts.create',
      EDIT: 'crm.subaccounts.edit',
      DELETE: 'crm.subaccounts.delete',
    },
    CONTACTS: {
      VIEW: 'crm.contacts.view',
      CREATE: 'crm.contacts.create',
      EDIT: 'crm.contacts.edit',
      DELETE: 'crm.contacts.delete',
    },
    PROJECTS: {
      VIEW: 'crm.projects.view',
      CREATE: 'crm.projects.create',
      EDIT: 'crm.projects.edit',
      DELETE: 'crm.projects.delete',
    },
    TASKS: {
      VIEW: 'crm.tasks.view',
      CREATE: 'crm.tasks.create',
      EDIT: 'crm.tasks.edit',
      DELETE: 'crm.tasks.delete',
    },
    ADDRESSES: {
      VIEW: 'crm.addresses.view',
      CREATE: 'crm.addresses.create',
      EDIT: 'crm.addresses.edit',
      DELETE: 'crm.addresses.delete',
    },
    NOTES: {
      VIEW: 'crm.notes.view',
      CREATE: 'crm.notes.create',
      EDIT: 'crm.notes.edit',
      DELETE: 'crm.notes.delete',
    },
  },
  HUB: {
    COMPANIES: {
      VIEW: 'hub.companies.view',
    },
    CONTACTS: {
      VIEW: 'hub.contacts.view',
    },
    LEADS: {
      VIEW: 'hub.leads.view',
    },
    DEALS: {
      VIEW: 'hub.deals.view',
    },
    TICKETS: {
      VIEW: 'hub.tickets.view',
    },
    JOBS: {
      VIEW: 'hub.jobs.view',
    },
    HELPDESK: {
      VIEW: 'hub.helpdesk.view',
    },
    CALLS: {
      VIEW: 'hub.calls.view',
    },
    MEETINGS: {
      VIEW: 'hub.meetings.view',
    },
    TASKS: {
      VIEW: 'hub.tasks.view',
    },
  },
  PIM: {
    PRODUCTS: {
      VIEW: 'pim.products.view',
      CREATE: 'pim.products.create',
      EDIT: 'pim.products.edit',
      DELETE: 'pim.products.delete',
      IMPORT: 'pim.products.import',
      EXPORT: 'pim.products.export',
      SAVE_FILTERS: 'pim.products.save_filters',
    },
    CATEGORIES: {
      VIEW: 'pim.categories.view',
      CREATE: 'pim.categories.create',
      EDIT: 'pim.categories.edit',
      DELETE: 'pim.categories.delete',
    },
    UNIVERSAL_INTAKE: {
      VIEW: 'pim.universal_intake.view',
      CREATE: 'pim.universal_intake.create',
      VIEW_ALL: 'pim.universal_intake.view_all',
      EDIT: 'pim.universal_intake.edit',
      DELETE: 'pim.universal_intake.delete',
    },
    PRINT_BRIDGE: {
      VIEW: 'pim.print_bridge.view',
      CREATE: 'pim.print_bridge.create',
      VIEW_ALL: 'pim.print_bridge.view_all',
      EDIT: 'pim.print_bridge.edit',
      DELETE: 'pim.print_bridge.delete',
    },
  },
  SURVEYS: {
    VIEW: 'surveys.surveys.view',
    CREATE: 'surveys.surveys.create',
    EDIT: 'surveys.surveys.edit',
    DELETE: 'surveys.surveys.delete',
  },
  INQUIRIES: {
    VIEW: 'surveys.inquiries.view',
    CREATE: 'surveys.inquiries.create',
    EDIT: 'surveys.inquiries.edit',
    DELETE: 'surveys.inquiries.delete',
    IMPORT: 'surveys.inquiries.import',
    EXPORT: 'surveys.inquiries.export',
  },
  RD: {
    TIMEPHASES: {
      VIEW: 'rd.timephases.view',
      CREATE: 'rd.timephases.create',
      EDIT: 'rd.timephases.edit',
      DELETE: 'rd.timephases.delete',
    },
    ESTIMATES: {
      VIEW: 'rd.estimates.view',
      CREATE: 'rd.estimates.create',
      EDIT: 'rd.estimates.edit',
      DELETE: 'rd.estimates.delete',
      EXPORT: 'rd.estimates.export',
    },
    DASHBOARDS: {
      VIEW: 'rd.dashboards.view',
    },
    FLASHREPORTS: {
      VIEW: 'rd.flashreports.view',
      CREATE: 'rd.flashreports.create',
      EDIT: 'rd.flashreports.edit',
      DELETE: 'rd.flashreports.delete',
    },
  },
  MACHINES: {
    VIEW: 'machines.machines.view',
    CREATE: 'machines.machines.create',
    EDIT: 'machines.machines.edit',
    DELETE: 'machines.machines.delete',
    IMPORT: 'machines.machines.import',
    EXPORT: 'machines.machines.export',
    MANAGE: 'machines.machines.manage',
  },
  OPERATIONS: {
    JOBS: {
      VIEW: 'operations.jobs.view',
    },
    DOWNTIME: {
      CREATE: 'operations.downtime.create',
    },
    ON_TIME_SHIPPING: {
      VIEW: 'operations.on_time_shipping.view',
      EDIT: 'operations.on_time_shipping.edit',
      EXPORT: 'operations.on_time_shipping.export',
    },
    REPORTS_DEMAND: {
      VIEW: 'operations.reports_demand.view',
    },
  },
  DESIGN: {
    QUEUE: {
      VIEW: 'design.queue.view',
      CREATE: 'design.queue.create',
      EDIT: 'design.queue.edit',
    },
    COMPLETED: {
      VIEW: 'design.completed.view',
    },
    HEAD: {
      PERMISSION: 'design.head.permission',
    },
  },
  PRODUCTS_DESIGN: {
    QUEUE: {
      VIEW: 'products_design.queue.view',
      EDIT: 'products_design.queue.edit',
      DELETE: 'products_design.queue.delete',
      EXPORT: 'products_design.queue.export',
    },
    SUPERVISOR: {
      VIEW: 'products_design.supervisor.view',
      EDIT: 'products_design.supervisor.edit',
    },
  },
  ORDER_ENTRY: {
    QUEUE: {
      VIEW: 'order_entry.queue.view',
    },
    ORDER: {
      CREATE: 'order_entry.order.create',
      EDIT: 'order_entry.order.edit',
      APPROVE: 'order_entry.order.approve',
      REJECT: 'order_entry.order.reject',
      VIEW_PROCESSED: 'order_entry.order.view_processed',
      VIEW_REJECTED: 'order_entry.order.view_rejected',
      VIEW_DECLINED: 'order_entry.order.view_declined',
    },
    GATEKEEPER: 'order_entry.gatekeeper',
  },
  PMO: {
    COORDINATOR_FORM: {
      VIEW: 'pmo.coordinator_form.view',
      CREATE: 'pmo.coordinator_form.create',
      VIEW_ALL: 'pmo.coordinator_form.view_all',
    },
    ADMIN_FORM: {
      VIEW: 'pmo.admin_form.view',
      CREATE: 'pmo.admin_form.create',
      VIEW_ALL: 'pmo.admin_form.view_all',
    },
    LEADER_FORM: {
      VIEW: 'pmo.leader_form.view',
      CREATE: 'pmo.leader_form.create',
      VIEW_ALL: 'pmo.leader_form.view_all',
    },
    DASHBOARD: {
      VIEW: 'pmo.dashboard.view',
      VIEW_ALL: 'pmo.dashboard.view_all',
    },
  },
  SALES: {
    DASHBOARD: {
      VIEW: 'sales.dashboard.view',
      EXPORT: 'sales.dashboard.export',
    },
    DASHBOARD_OLD: {
      VIEW: 'sales.dashboard_old.view',
    },
    PERFORMANCE: {
      VIEW: 'sales.performance.view',
      EXPORT: 'sales.performance.export',
    },
    LEADERBOARD: {
      VIEW: 'sales.leaderboard.view',
      EXPORT: 'sales.leaderboard.export',
    },
    OPEN_PIPELINE: {
      VIEW: 'sales.open_pipeline.view',
    },
    SALES_DETAIL: {
      VIEW: 'sales.sales_detail.view',
      EXPORT: 'sales.sales_detail.export',
    },
    AMAZON_DASHBOARD: {
      VIEW: 'sales.amazon_dashboard.view',
      EXPORT: 'sales.amazon_dashboard.export',
    },
    INBOUND_ORDERS: {
      VIEW: 'sales.inbound_orders.view',
      EXPORT: 'sales.inbound_orders.export',
    },
    REP_METRICS: {
      VIEW: 'sales.rep_metrics.view',
      EXPORT: 'sales.rep_metrics.export',
    },
    INQUIRIES: {
      VIEW: 'sales.inquiries.view',
      CREATE: 'sales.inquiries.create',
      EDIT: 'sales.inquiries.edit',
      DELETE: 'sales.inquiries.delete',
      IMPORT: 'sales.inquiries.import',
      EXPORT: 'sales.inquiries.export',
    },
    BUDGETS: {
      VIEW: 'sales.budgets.view',
      CREATE: 'sales.budgets.create',
      EDIT: 'sales.budgets.edit',
      IMPORT: 'sales.budgets.import',
      EXPORT: 'sales.budgets.export',
    },
    TEAMS_REPS: {
      VIEW: 'sales.teams_reps.view',
      EDIT: 'sales.teams_reps.edit',
      IMPORT: 'sales.teams_reps.import',
      EXPORT: 'sales.teams_reps.export',
    },
    WORKFLOW_NEW_PRODUCT: {
      VIEW: 'sales.workflow_new_product.view',
      CREATE: 'sales.workflow_new_product.create',
      EDIT: 'sales.workflow_new_product.edit',
    },
    WORKFLOW_MODIFY: {
      VIEW: 'sales.workflow_modify.view',
      CREATE: 'sales.workflow_modify.create',
      EDIT: 'sales.workflow_modify.edit',
    },
    WORKFLOW_PRODUCT_BUNDLE: {
      VIEW: 'sales.workflow_product_bundle.view',
      CREATE: 'sales.workflow_product_bundle.create',
      EDIT: 'sales.workflow_product_bundle.edit',
    },
    WORKFLOW_NEW_CUSTOMER_ORDER: {
      VIEW: 'sales.workflow_new_customer_order.view',
      CREATE: 'sales.workflow_new_customer_order.create',
      EDIT: 'sales.workflow_new_customer_order.edit',
    },
    WORKFLOW_SUBMITTED: {
      VIEW: 'sales.workflow_submitted.view',
      EDIT: 'sales.workflow_submitted.edit',
      DELETE: 'sales.workflow_submitted.delete',
    },
    CUSTOMER_SETUP: {
      VIEW: 'sales.customer_setup.view',
      CREATE: 'sales.customer_setup.create',
    },
    CUSTOMER_SETUP_SETTINGS: {
      VIEW: 'sales.customer_setup_settings.view',
      EDIT: 'sales.customer_setup_settings.edit',
    },
  },
  SALESHISTORY: {
    VIEW: 'saleshistory.saleshistory.view',
    IMPORT: 'saleshistory.saleshistory.import',
    EXPORT: 'saleshistory.saleshistory.export',
    TRENDS: {
      VIEW: 'saleshistory.trends.view',
      EXPORT: 'saleshistory.trends.export',
    },
  },
  ANALYTICS: {
    DWELL_TIME: {
      VIEW: 'analytics.dwell_time.view',
      EXPORT: 'analytics.dwell_time.export',
    },
    SYSTEMS_UPTIME: {
      VIEW: 'analytics.systems_uptime.view',
    },
  },
  QUALITY: {
    CLAIMS: {
      VIEW: 'quality.claims.view',
      CREATE: 'quality.claims.create',
      EDIT: 'quality.claims.edit',
      DELETE: 'quality.claims.delete',
    },
    CLAIM_REVIEW: {
      EDIT: 'quality.claim_review.edit',
    },
  },
  ZOOM: {
    DASHBOARD: {
      VIEW: 'zoom.dashboard.view',
      EDIT: 'zoom.dashboard.edit',
    },
  },
  ADMIN: {
    USERS: {
      VIEW: 'admin.users.view',
      CREATE: 'admin.users.create',
      EDIT: 'admin.users.edit',
      DELETE: 'admin.users.delete',
      IMPORT: 'admin.users.import',
      EXPORT: 'admin.users.export',
    },
    INVITES: {
      VIEW: 'admin.invites.view',
      CREATE: 'admin.invites.create',
      EDIT: 'admin.invites.edit',
      DELETE: 'admin.invites.delete',
    },
    ROLES: {
      VIEW: 'admin.roles.view',
      CREATE: 'admin.roles.create',
      EDIT: 'admin.roles.edit',
      DELETE: 'admin.roles.delete',
      IMPORT: 'admin.roles.import',
      EXPORT: 'admin.roles.export',
    },
    PERMISSIONS: {
      VIEW: 'admin.permissions.view',
    },
    RBAC: {
      VIEW: 'admin.rbac.view',
      CREATE: 'admin.rbac.create',
      EDIT: 'admin.rbac.edit',
      DELETE: 'admin.rbac.delete',
    },
    BUGREPORTS: {
      VIEW: 'admin.bugreports.view',
      CREATE: 'admin.bugreports.create',
      EDIT: 'admin.bugreports.edit',
      DELETE: 'admin.bugreports.delete',
    },
    BACKUPS: {
      VIEW: 'admin.backups.view',
      CREATE: 'admin.backups.create',
      EDIT: 'admin.backups.edit',
      DELETE: 'admin.backups.delete',
    },
    DATABASE_IMPORT_EXPORT: {
      VIEW: 'admin.database_import_export.view',
    },
    EXTERNALDATA: {
      VIEW: 'admin.externaldata.view',
      CREATE: 'admin.externaldata.create',
      EDIT: 'admin.externaldata.edit',
      DELETE: 'admin.externaldata.delete',
      EXPORT: 'admin.externaldata.export',
    },
    LOGS: {
      VIEW: 'admin.logs.view',
    },
    NAVIGATION: {
      VIEW: 'admin.navigation.view',
      EDIT: 'admin.navigation.edit',
    },
    CONTROLS: {
      VIEW: 'admin.controls.view',
      EDIT: 'admin.controls.edit',
    },
    INFIGO_CONTROLS: {
      VIEW: 'admin.infigo_controls.view',
      EDIT: 'admin.infigo_controls.edit',
    },
    APP_SETTINGS: {
      VIEW: 'admin.app_settings.view',
      EDIT: 'admin.app_settings.edit',
    },
    TEAMS: {
      VIEW: 'admin.teams.view',
      CREATE: 'admin.teams.create',
      EDIT: 'admin.teams.edit',
      DELETE: 'admin.teams.delete',
      CREATE_DEPARTMENT: 'admin.teams.create-department',
      ADMIN: 'admin.teams.admin',
      EXPORT: 'admin.teams.export',
      IMPORT: 'admin.teams.import',
    },
    SALESREPS: {
      VIEW: 'admin.salesreps.view',
      CREATE: 'admin.salesreps.create',
      DELETE: 'admin.salesreps.delete',
    },
    API_KEYS: {
      VIEW: 'admin.api_keys.view',
      CREATE: 'admin.api_keys.create',
      EDIT: 'admin.api_keys.edit',
    },
    INNOVATOR_APPS: {
      VIEW: 'admin.innovator_apps.view',
      EDIT: 'admin.innovator_apps.edit',
    },
  },
  SYSTEM: {
    SUPER_ADMIN: 'super.admin',
    SUPER: {
      ADMIN: 'super.admin',
    },
  },
} as const;

/** Every PMO Weekly Check-In Spatie permission (module access / sidebar / route guards). */
export const PMO_WEEKLY_CHECK_IN_ALL_PERMISSIONS = [
  PERMISSIONS.PMO.COORDINATOR_FORM.VIEW,
  PERMISSIONS.PMO.COORDINATOR_FORM.CREATE,
  PERMISSIONS.PMO.COORDINATOR_FORM.VIEW_ALL,
  PERMISSIONS.PMO.ADMIN_FORM.VIEW,
  PERMISSIONS.PMO.ADMIN_FORM.CREATE,
  PERMISSIONS.PMO.ADMIN_FORM.VIEW_ALL,
  PERMISSIONS.PMO.LEADER_FORM.VIEW,
  PERMISSIONS.PMO.LEADER_FORM.CREATE,
  PERMISSIONS.PMO.LEADER_FORM.VIEW_ALL,
  PERMISSIONS.PMO.DASHBOARD.VIEW,
  PERMISSIONS.PMO.DASHBOARD.VIEW_ALL,
] as const

/** At least one of these is required to open the Project Coordinator weekly check-in form route. */
export const PMO_COORDINATOR_FORM_ANY_PERMISSIONS = [
  PERMISSIONS.PMO.COORDINATOR_FORM.VIEW,
  PERMISSIONS.PMO.COORDINATOR_FORM.CREATE,
  PERMISSIONS.PMO.COORDINATOR_FORM.VIEW_ALL,
] as const
